
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h16.005C17.107 0 18 .898 18 1.99v16.02c0 1.099-.893 1.99-1.995 1.99H0V0zm4 2H2v16h2V2zm2 16h10V2H6v16zm2-4a3 3 0 016 0H8zm3-4a2 2 0 110-4 2 2 0 010 4zm8-6h2v4h-2V4zm0 6h2v4h-2v-4z","fill":"#FAAD14"}})])
          )
        }
      }
    